<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { missingParts } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="missingParts.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading as="th">
            {{ missingParts.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <SectionsDetailsPdfElementsList
            v-if="missingParts.list.length"
            :elements="missingParts.list"
            :in-two-cols-from="missingParts.twoColumnsFrom"
          />

          <SectionsDetailsPdfElementsFreeText
            v-if="missingParts.freeText.length"
            :has-border="missingParts.list.length > 0"
            :free-text="missingParts.freeText"
          />
        </tbody>
      </table>
    </td>
  </tr>
</template>
